import React, { useState } from "react";
import { Button, Dialog, Paragraph, toaster, RedoIcon, Pane, majorScale } from "evergreen-ui";
import { useOffer } from "../context/offerContext";
import { Offer, OfferStatus } from "../api/offers";

const canRetractAndRefundOffer = (offer: Offer) => {
  if ([OfferStatus.ACTIVE, OfferStatus.REVIEW].includes(offer.status)) {
    // Active/Review offers with zero payment can be retracted but not retracted and refunded (nothing to refund)
    if (!offer.payment || offer.price === 0) {
      return false;
    }
    return true;
  }

  return false;
};

const RetractAndRefund = ({ id }: { id: string }) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const [saving, setSaving] = useState(false);
  const { offer, retractAndRefund } = useOffer(id);

  if (!offer || !canRetractAndRefundOffer(offer)) return null;

  const handleConfirm = async () => {
    setSaving(true);

    try {
      await retractAndRefund(offer);
      toaster.success("Successfully retracted and refunded");
      setSaving(false);
      setShowConfirm(false);
      return;
    } catch (err: any) {
      toaster.danger("Error: " + err.message);
      setSaving(false);
    }
  };

  return (
    <Pane marginLeft={majorScale(2)}>
      <Dialog
        isShown={showConfirm}
        title="Retract and Refund"
        onCloseComplete={() => setShowConfirm(false)}
        confirmLabel="Confirm"
        onConfirm={handleConfirm}
        isConfirmLoading={saving}
      >
        <Paragraph>Please confirm that you'd like to RETRACT and REFUND this offer.</Paragraph>
      </Dialog>
      <Button iconBefore={RedoIcon} onClick={() => setShowConfirm(true)}>
        Retract and Refund
      </Button>
    </Pane>
  );
};

export default RetractAndRefund;
